import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {thunk} from "redux-thunk"; // Fix: Use named import for thunk
import usersSlice from "../redux/users/usersSlice"; // Fix: Correct relative import path

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: usersSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // Fix: Use middleware chaining to add thunk
});

export const persistorRedux = persistStore(store);
